/* tslint:disable */
/* eslint-disable */
/**
 * ELOfleet API Documentation
 * Backend of the ELOfleet fleet management system
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import {
    type ErrorResponse,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
} from '../models/ErrorResponse';
import {
    type PageInfo,
    PageInfoFromJSON,
    PageInfoToJSON,
} from '../models/PageInfo';
import {
    type SortDirection,
    SortDirectionFromJSON,
    SortDirectionToJSON,
} from '../models/SortDirection';
import {
    type UserGroup,
    UserGroupFromJSON,
    UserGroupToJSON,
} from '../models/UserGroup';
import {
    type UserGroupCreate,
    UserGroupCreateFromJSON,
    UserGroupCreateToJSON,
} from '../models/UserGroupCreate';
import {
    type UserGroupSortKey,
    UserGroupSortKeyFromJSON,
    UserGroupSortKeyToJSON,
} from '../models/UserGroupSortKey';
import {
    type UserGroupUpdate,
    UserGroupUpdateFromJSON,
    UserGroupUpdateToJSON,
} from '../models/UserGroupUpdate';

export interface UserGroupsCreateUserGroupRequest {
    userGroupCreate: UserGroupCreate;
}

export interface UserGroupsDeleteUserGroupRequest {
    userGroupId: string;
}

export interface UserGroupsListUserGroupsRequest {
    pageSize: number;
    search?: string | null;
    vehicleGroupIds?: Array<string> | null;
    page?: number | null;
    sortDirection?: SortDirection;
    sortKey?: UserGroupSortKey;
}

export interface UserGroupsListUserGroupsMetadataRequest {
    pageSize: number;
    search?: string | null;
    vehicleGroupIds?: Array<string> | null;
}

export interface UserGroupsReadUserGroupRequest {
    userGroupId: string;
}

export interface UserGroupsUpdateUserGroupRequest {
    userGroupId: string;
    userGroupUpdate: UserGroupUpdate;
}

export interface UserGroupsValidateCreateUserGroupRequest {
    userGroupCreate: UserGroupCreate;
}

export interface UserGroupsValidateUpdateUserGroupRequest {
    userGroupId: string;
    userGroupUpdate: UserGroupUpdate;
}

/**
 * UserGroupsApi - interface
 * 
 * @export
 * @interface UserGroupsApiInterface
 */
export interface UserGroupsApiInterface {
    /**
     * Creates request options for userGroupsCreateUserGroup without sending the request
     * @param {UserGroupCreate} userGroupCreate 
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsCreateUserGroupRequestOpts(requestParameters: UserGroupsCreateUserGroupRequest): Promise<runtime.RequestOpts>;

    /**
     * Create a new user group.
     * @summary Create a user group
     * @param {UserGroupCreate} userGroupCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsCreateUserGroupRaw(requestParameters: UserGroupsCreateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroup>>;

    /**
     * Create a new user group.
     * Create a user group
     */
    userGroupsCreateUserGroup(requestParameters: UserGroupsCreateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroup>;

    /**
     * Creates request options for userGroupsDeleteUserGroup without sending the request
     * @param {string} userGroupId 
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsDeleteUserGroupRequestOpts(requestParameters: UserGroupsDeleteUserGroupRequest): Promise<runtime.RequestOpts>;

    /**
     * Delete the user group with the given ID.
     * @summary Delete a user group
     * @param {string} userGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsDeleteUserGroupRaw(requestParameters: UserGroupsDeleteUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Delete the user group with the given ID.
     * Delete a user group
     */
    userGroupsDeleteUserGroup(requestParameters: UserGroupsDeleteUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for userGroupsListUserGroups without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {Array<string>} [vehicleGroupIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {UserGroupSortKey} [sortKey] 
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsListUserGroupsRequestOpts(requestParameters: UserGroupsListUserGroupsRequest): Promise<runtime.RequestOpts>;

    /**
     * Lists all the user groups present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * @summary List user groups
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {Array<string>} [vehicleGroupIds] 
     * @param {number} [page] 
     * @param {SortDirection} [sortDirection] 
     * @param {UserGroupSortKey} [sortKey] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsListUserGroupsRaw(requestParameters: UserGroupsListUserGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserGroup>>>;

    /**
     * Lists all the user groups present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List user groups
     */
    userGroupsListUserGroups(requestParameters: UserGroupsListUserGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserGroup>>;

    /**
     * Creates request options for userGroupsListUserGroupsMetadata without sending the request
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {Array<string>} [vehicleGroupIds] 
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsListUserGroupsMetadataRequestOpts(requestParameters: UserGroupsListUserGroupsMetadataRequest): Promise<runtime.RequestOpts>;

    /**
     * Fetch information about the total amount of pages available.
     * @summary User group listing metadata
     * @param {number} pageSize 
     * @param {string} [search] 
     * @param {Array<string>} [vehicleGroupIds] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsListUserGroupsMetadataRaw(requestParameters: UserGroupsListUserGroupsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>>;

    /**
     * Fetch information about the total amount of pages available.
     * User group listing metadata
     */
    userGroupsListUserGroupsMetadata(requestParameters: UserGroupsListUserGroupsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo>;

    /**
     * Creates request options for userGroupsReadUserGroup without sending the request
     * @param {string} userGroupId 
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsReadUserGroupRequestOpts(requestParameters: UserGroupsReadUserGroupRequest): Promise<runtime.RequestOpts>;

    /**
     * Returns the user group specified by the given ID.
     * @summary Get a single user group
     * @param {string} userGroupId 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsReadUserGroupRaw(requestParameters: UserGroupsReadUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroup>>;

    /**
     * Returns the user group specified by the given ID.
     * Get a single user group
     */
    userGroupsReadUserGroup(requestParameters: UserGroupsReadUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroup>;

    /**
     * Creates request options for userGroupsUpdateUserGroup without sending the request
     * @param {string} userGroupId 
     * @param {UserGroupUpdate} userGroupUpdate 
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsUpdateUserGroupRequestOpts(requestParameters: UserGroupsUpdateUserGroupRequest): Promise<runtime.RequestOpts>;

    /**
     * Update the user group specified by the given ID.
     * @summary Update user group
     * @param {string} userGroupId 
     * @param {UserGroupUpdate} userGroupUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsUpdateUserGroupRaw(requestParameters: UserGroupsUpdateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroup>>;

    /**
     * Update the user group specified by the given ID.
     * Update user group
     */
    userGroupsUpdateUserGroup(requestParameters: UserGroupsUpdateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroup>;

    /**
     * Creates request options for userGroupsValidateCreateUserGroup without sending the request
     * @param {UserGroupCreate} userGroupCreate 
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsValidateCreateUserGroupRequestOpts(requestParameters: UserGroupsValidateCreateUserGroupRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for a new user group without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate a user group
     * @param {UserGroupCreate} userGroupCreate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsValidateCreateUserGroupRaw(requestParameters: UserGroupsValidateCreateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for a new user group without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a user group
     */
    userGroupsValidateCreateUserGroup(requestParameters: UserGroupsValidateCreateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Creates request options for userGroupsValidateUpdateUserGroup without sending the request
     * @param {string} userGroupId 
     * @param {UserGroupUpdate} userGroupUpdate 
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsValidateUpdateUserGroupRequestOpts(requestParameters: UserGroupsValidateUpdateUserGroupRequest): Promise<runtime.RequestOpts>;

    /**
     * Validate data for updating the given user group, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * @summary Validate user group update
     * @param {string} userGroupId 
     * @param {UserGroupUpdate} userGroupUpdate 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof UserGroupsApiInterface
     */
    userGroupsValidateUpdateUserGroupRaw(requestParameters: UserGroupsValidateUpdateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Validate data for updating the given user group, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate user group update
     */
    userGroupsValidateUpdateUserGroup(requestParameters: UserGroupsValidateUpdateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class UserGroupsApi extends runtime.BaseAPI implements UserGroupsApiInterface {

    /**
     * Creates request options for userGroupsCreateUserGroup without sending the request
     */
    async userGroupsCreateUserGroupRequestOpts(requestParameters: UserGroupsCreateUserGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroupCreate'] == null) {
            throw new runtime.RequiredError(
                'userGroupCreate',
                'Required parameter "userGroupCreate" was null or undefined when calling userGroupsCreateUserGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_groups/`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupCreateToJSON(requestParameters['userGroupCreate']),
        };
    }

    /**
     * Create a new user group.
     * Create a user group
     */
    async userGroupsCreateUserGroupRaw(requestParameters: UserGroupsCreateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroup>> {
        const requestOptions = await this.userGroupsCreateUserGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserGroupFromJSON(jsonValue));
    }

    /**
     * Create a new user group.
     * Create a user group
     */
    async userGroupsCreateUserGroup(requestParameters: UserGroupsCreateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroup> {
        const response = await this.userGroupsCreateUserGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupsDeleteUserGroup without sending the request
     */
    async userGroupsDeleteUserGroupRequestOpts(requestParameters: UserGroupsDeleteUserGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroupId'] == null) {
            throw new runtime.RequiredError(
                'userGroupId',
                'Required parameter "userGroupId" was null or undefined when calling userGroupsDeleteUserGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_groups/{user_group_id}`;
        urlPath = urlPath.replace('{user_group_id}', encodeURIComponent(String(requestParameters['userGroupId'])));

        return {
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Delete the user group with the given ID.
     * Delete a user group
     */
    async userGroupsDeleteUserGroupRaw(requestParameters: UserGroupsDeleteUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.userGroupsDeleteUserGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Delete the user group with the given ID.
     * Delete a user group
     */
    async userGroupsDeleteUserGroup(requestParameters: UserGroupsDeleteUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userGroupsDeleteUserGroupRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for userGroupsListUserGroups without sending the request
     */
    async userGroupsListUserGroupsRequestOpts(requestParameters: UserGroupsListUserGroupsRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userGroupsListUserGroups().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['vehicleGroupIds'] != null) {
            queryParameters['vehicle_group_ids'] = requestParameters['vehicleGroupIds'];
        }

        if (requestParameters['page'] != null) {
            queryParameters['page'] = requestParameters['page'];
        }

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['sortDirection'] != null) {
            queryParameters['sort_direction'] = requestParameters['sortDirection'];
        }

        if (requestParameters['sortKey'] != null) {
            queryParameters['sort_key'] = requestParameters['sortKey'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_groups/`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Lists all the user groups present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List user groups
     */
    async userGroupsListUserGroupsRaw(requestParameters: UserGroupsListUserGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<UserGroup>>> {
        const requestOptions = await this.userGroupsListUserGroupsRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(UserGroupFromJSON));
    }

    /**
     * Lists all the user groups present. If `search` is specified, return values similar to the `label` field, and `sortKey` will not have any effect: results will be sorted by similarity to the search term instead.
     * List user groups
     */
    async userGroupsListUserGroups(requestParameters: UserGroupsListUserGroupsRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<UserGroup>> {
        const response = await this.userGroupsListUserGroupsRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupsListUserGroupsMetadata without sending the request
     */
    async userGroupsListUserGroupsMetadataRequestOpts(requestParameters: UserGroupsListUserGroupsMetadataRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['pageSize'] == null) {
            throw new runtime.RequiredError(
                'pageSize',
                'Required parameter "pageSize" was null or undefined when calling userGroupsListUserGroupsMetadata().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['pageSize'] != null) {
            queryParameters['page_size'] = requestParameters['pageSize'];
        }

        if (requestParameters['search'] != null) {
            queryParameters['search'] = requestParameters['search'];
        }

        if (requestParameters['vehicleGroupIds'] != null) {
            queryParameters['vehicle_group_ids'] = requestParameters['vehicleGroupIds'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_groups/meta`;

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Fetch information about the total amount of pages available.
     * User group listing metadata
     */
    async userGroupsListUserGroupsMetadataRaw(requestParameters: UserGroupsListUserGroupsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<PageInfo>> {
        const requestOptions = await this.userGroupsListUserGroupsMetadataRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => PageInfoFromJSON(jsonValue));
    }

    /**
     * Fetch information about the total amount of pages available.
     * User group listing metadata
     */
    async userGroupsListUserGroupsMetadata(requestParameters: UserGroupsListUserGroupsMetadataRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<PageInfo> {
        const response = await this.userGroupsListUserGroupsMetadataRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupsReadUserGroup without sending the request
     */
    async userGroupsReadUserGroupRequestOpts(requestParameters: UserGroupsReadUserGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroupId'] == null) {
            throw new runtime.RequiredError(
                'userGroupId',
                'Required parameter "userGroupId" was null or undefined when calling userGroupsReadUserGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_groups/{user_group_id}`;
        urlPath = urlPath.replace('{user_group_id}', encodeURIComponent(String(requestParameters['userGroupId'])));

        return {
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        };
    }

    /**
     * Returns the user group specified by the given ID.
     * Get a single user group
     */
    async userGroupsReadUserGroupRaw(requestParameters: UserGroupsReadUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroup>> {
        const requestOptions = await this.userGroupsReadUserGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserGroupFromJSON(jsonValue));
    }

    /**
     * Returns the user group specified by the given ID.
     * Get a single user group
     */
    async userGroupsReadUserGroup(requestParameters: UserGroupsReadUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroup> {
        const response = await this.userGroupsReadUserGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupsUpdateUserGroup without sending the request
     */
    async userGroupsUpdateUserGroupRequestOpts(requestParameters: UserGroupsUpdateUserGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroupId'] == null) {
            throw new runtime.RequiredError(
                'userGroupId',
                'Required parameter "userGroupId" was null or undefined when calling userGroupsUpdateUserGroup().'
            );
        }

        if (requestParameters['userGroupUpdate'] == null) {
            throw new runtime.RequiredError(
                'userGroupUpdate',
                'Required parameter "userGroupUpdate" was null or undefined when calling userGroupsUpdateUserGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_groups/{user_group_id}`;
        urlPath = urlPath.replace('{user_group_id}', encodeURIComponent(String(requestParameters['userGroupId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupUpdateToJSON(requestParameters['userGroupUpdate']),
        };
    }

    /**
     * Update the user group specified by the given ID.
     * Update user group
     */
    async userGroupsUpdateUserGroupRaw(requestParameters: UserGroupsUpdateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<UserGroup>> {
        const requestOptions = await this.userGroupsUpdateUserGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => UserGroupFromJSON(jsonValue));
    }

    /**
     * Update the user group specified by the given ID.
     * Update user group
     */
    async userGroupsUpdateUserGroup(requestParameters: UserGroupsUpdateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<UserGroup> {
        const response = await this.userGroupsUpdateUserGroupRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Creates request options for userGroupsValidateCreateUserGroup without sending the request
     */
    async userGroupsValidateCreateUserGroupRequestOpts(requestParameters: UserGroupsValidateCreateUserGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroupCreate'] == null) {
            throw new runtime.RequiredError(
                'userGroupCreate',
                'Required parameter "userGroupCreate" was null or undefined when calling userGroupsValidateCreateUserGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_groups/validate`;

        return {
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupCreateToJSON(requestParameters['userGroupCreate']),
        };
    }

    /**
     * Validate data for a new user group without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a user group
     */
    async userGroupsValidateCreateUserGroupRaw(requestParameters: UserGroupsValidateCreateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.userGroupsValidateCreateUserGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for a new user group without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate a user group
     */
    async userGroupsValidateCreateUserGroup(requestParameters: UserGroupsValidateCreateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userGroupsValidateCreateUserGroupRaw(requestParameters, initOverrides);
    }

    /**
     * Creates request options for userGroupsValidateUpdateUserGroup without sending the request
     */
    async userGroupsValidateUpdateUserGroupRequestOpts(requestParameters: UserGroupsValidateUpdateUserGroupRequest): Promise<runtime.RequestOpts> {
        if (requestParameters['userGroupId'] == null) {
            throw new runtime.RequiredError(
                'userGroupId',
                'Required parameter "userGroupId" was null or undefined when calling userGroupsValidateUpdateUserGroup().'
            );
        }

        if (requestParameters['userGroupUpdate'] == null) {
            throw new runtime.RequiredError(
                'userGroupUpdate',
                'Required parameter "userGroupUpdate" was null or undefined when calling userGroupsValidateUpdateUserGroup().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("HttpAuth", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/user_groups/{user_group_id}/validate`;
        urlPath = urlPath.replace('{user_group_id}', encodeURIComponent(String(requestParameters['userGroupId'])));

        return {
            path: urlPath,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: UserGroupUpdateToJSON(requestParameters['userGroupUpdate']),
        };
    }

    /**
     * Validate data for updating the given user group, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate user group update
     */
    async userGroupsValidateUpdateUserGroupRaw(requestParameters: UserGroupsValidateUpdateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const requestOptions = await this.userGroupsValidateUpdateUserGroupRequestOpts(requestParameters);
        const response = await this.request(requestOptions, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Validate data for updating the given user group, without persisting it. Return an empty body if the data is valid. Return validation errors if it is invalid.
     * Validate user group update
     */
    async userGroupsValidateUpdateUserGroup(requestParameters: UserGroupsValidateUpdateUserGroupRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.userGroupsValidateUpdateUserGroupRaw(requestParameters, initOverrides);
    }

}
